import Card from './components/Card';
import './App.css';

function App() {
  return (
    <div className="app">
     <Card/>
    </div>
  );
}

export default App;
